import config from './config';
import request from './request';

export default { request, config };
